import PropTypes from 'prop-types'
import { useEffect, useMemo, useRef, useState } from 'react'

import { SearchOrAddData } from '@components/common'
import { AdasPaper, AdasTable, AdasBox, AdasStack, AdasPagination } from '@components/wrapper-components'
import { TABLE_HEADER_STYLE } from '../../../constants'
import { useUserStore } from '../../../store'
import { ItemPerPageSelector } from '@components/common'

export const ProductList = ({
  products = [],
  onAddProduct,
  onSelectProduct,
  columns,
  pageParams,
  pageSizeHandler,
  paginationHandler,
  searchInput,
  setSearchInput,
  selectedProfileType
}) => {
  const [productsDisplayed, setProductsDisplayed] = useState(products)
  const [sort, setSort] = useState('ASC')
  const initialLoad = useRef(true)
  const user = useUserStore((store) => store.currentUser)
  // const columns = displayCategory ? PRODUCT_LIST_HEADERS : SERVICE_LIST_HEADERS

  const searchInputHandler = (e) => {
    setSearchInput(e.target.value)
  }

  const clickSortHandler = (id) => {
    initialLoad.current = false
    if (id === 'name') setSort(sort === 'ASC' ? 'DESC' : 'ASC')
  }

  useEffect(() => {
    if (!initialLoad.current) {
      setProductsDisplayed((prevList) => {
        const resultList = reverseArray(prevList)
        return resultList
      })
    }
  }, [sort])

  useEffect(() => {
    setProductsDisplayed(products)
  }, [products])

  const isTechUser = useMemo(() => {
    if (user) {
      return !(user.is_admin || user.is_manager || user.is_owner)
    }
    return false
  }, [user])

  const reverseArray = (array) => [...array].reverse()

  return (
    <>
      <AdasPaper
        sx={{
          padding: '20px 20px',
          backgroundColor: 'white',
          marginTop: '20px'
        }}
      >
        <SearchOrAddData
          variant={isTechUser || selectedProfileType === 'national' ? 'withAddButtonDisabled' : 'withAddButton'}
          searchInput={searchInput}
          searchInputHandler={searchInputHandler}
          onAddClick={() => onAddProduct(true)}
        />
        {products.length > 0 ? (
          <>
            <AdasTable
              containerProps={{ sx: { backgroundColor: '#ffff' } }}
              tableProps={{
                sx: {
                  marginTop: '20px',
                  '.MuiTableCell-root': { border: 'none', padding: '2px 10px' },
                  overflowX: 'scroll'
                },
                'aria-label': 'products table'
              }}
              columns={columns}
              sortField='name'
              sortDirection={sort}
              onSort={clickSortHandler}
              headerStyle={TABLE_HEADER_STYLE}
              data={productsDisplayed}
              onSelect={onSelectProduct}
            />
          </>
        ) : (
          <AdasBox display='flex' alignItems='center' justifyContent='center' minHeight='200px'>
            No Products Found
          </AdasBox>
        )}
      </AdasPaper>
      {products.length > 0 && (
        <AdasPaper
          elevation={0}
          sx={{ padding: '20px', marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <AdasBox sx={{ width: '20%' }}>
            <ItemPerPageSelector itemPerPageList={[25, 50, 100, 200]} pageSizeHandler={pageSizeHandler} pageSize={pageParams.pageSize} />
          </AdasBox>
          <AdasBox>
            <AdasStack spacing={2}>
              <AdasPagination onChange={paginationHandler} page={pageParams.pageNo + 1} count={pageParams.totalPages} shape='rounded' />
            </AdasStack>
          </AdasBox>
        </AdasPaper>
      )}
    </>
  )
}

ProductList.propTypes = {
  products: PropTypes.array,
  onAddProduct: PropTypes.func.isRequired,
  onSelectProduct: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  pageParams: PropTypes.shape({
    pageNo: PropTypes.number,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    totalCount: PropTypes.number
  }).isRequired,
  pageSizeHandler: PropTypes.func.isRequired,
  paginationHandler: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  setSearchInput: PropTypes.func.isRequired
}
